// App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Example from './components/Example';
import Faucet from './components/Faucet';
import Airdrop from './components/Airdrop';
import NotFound from './components/NotFound';

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route exact path="/" element={<Faucet/>} />
          {/* <Route exact path="/test" element={<Example/>} />
          <Route exact path="/faucet" element={<Faucet/>} />
          <Route exact path="/airdrop" element={<Airdrop/>} /> */}
          <Route element={<NotFound/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
